import { fetchApi } from '@/config/axiosSetting';
import { PatchBodyCertificationQueryParamsType } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodyCertification/patchBodyCertificationQuery.type';

export const patchBodyCertificationQueryFunction = (
  params: PatchBodyCertificationQueryParamsType,
) => {
  return fetchApi.patch(
    `body/reports/${params?.id}/insurer_information/driver/certificate_information/`,
    params?.data,
  );
};
